import { render } from "./SignNameCanvas.vue?vue&type=template&id=c23f65ac&scoped=true"
import script from "./SignNameCanvas.vue?vue&type=script&lang=js"
export * from "./SignNameCanvas.vue?vue&type=script&lang=js"

import "./SignNameCanvas.vue?vue&type=style&index=0&id=c23f65ac&lang=css&scoped=true"

import exportComponent from "D:\\projects\\wmsapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c23f65ac"]])

export default __exports__